<template>
  <v-row justify="center">
    <v-dialog v-model="show" max-width="650px">
      <v-card>
        <v-card-title style="word-break: normal !important; justify-content: center;">{{modalTitle}}</v-card-title>
        <v-card-text>
          <delivery-constraints
            ref="deliveryConstraints"
            v-if='typeof deliveryConstraints === "object" && Object.keys(deliveryConstraints).length'
            :deliveryConstraints="deliveryConstraints"
            :areNewConstraints="areNewConstraints"
            :currency="currency"
          >
          </delivery-constraints>
        </v-card-text>
        <v-card-actions class="pa-0" v-if='areNewConstraints'>
          <v-btn
            color="primary"
            tile
            class="ml-0"
            style="width: 50%;"
            @click="addDeliveryConstraint"
            :loading="loading"
            :disabled="loading"
          >{{$t("deliveryMethod.validate")}}</v-btn>
          <v-btn
            color="secondary"
            tile
            class="ml-0"
            style="width: 50%;"
            @click="cancelAddDeliveryConstraint"
            :loading="loading"
            :disabled="loading"
          >{{$t("deliveryMethod.cancel")}}</v-btn>
        </v-card-actions>
        <v-card-actions class="pa-0" v-else>
          <v-btn
            color="primary"
            tile
            class="ml-0"
            style="width: 50%;"
            @click="updateDeliveryConstraint"
            :loading="loading"
            :disabled="loading"
          >{{$t("deliveryMethod.validate")}}</v-btn>
          <v-btn
            color="primary"
            tile
            class="ml-0"
            style="width: 50%;"
            @click="cancelAddDeliveryConstraint"
            :loading="loading"
            :disabled="loading"
          >{{$t("deliveryMethod.close")}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>


<script>
  import deliveryConstraints from '@/components/carriers/deliveryMethods/deliveryConstraints/DeliveryConstraints'
  import { EventBus } from '@/event-bus'

  export default {
    name: "deliveryConstraintsDialog",
    components: {
      deliveryConstraints
    },
    props: {
      title: {
        type: String,
        default: undefined
      },
      deliveryConstraints: {
        type: Object,
        default: null,
      },
      currency: {
        type: String,
        default: "EUR"
      },
      areNewConstraints: {
        type: Boolean,
        default: false
      },
      value: {
        type: Boolean,
        default: false
      },
      loading: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      show: {
        get() {
          return this.value;
        },
        set(value) {
          this.$emit("input", value);
        }
      },
      modalTitle: function(){
        if(!this.title){
          return this.$t("components.modalConfirmation.defaultTitle")
        }
        else return this.title
      },
      modalText: function(){
        if(!this.text){
          return this.$t("components.modalConfirmation.defaultText")
        }
        else return this.text
      }
    },
    methods: {
      async addDeliveryConstraint() {
        if(await this.$refs.deliveryConstraints.validateForm()){
          this.$emit('add-delivery-constraint', this.deliveryConstraints)
        } else {
          {
            EventBus.$emit('displaySnackbar', {
              display: true,
              text: this.$t('deliveryMethod.incorrectFormFields'),
              color: 'error'
            })
          }
        }
      },
      cancelAddDeliveryConstraint() {
        this.$emit('cancel-add-delivery-constraint')
      },
      async updateDeliveryConstraint() {
        if(await this.$refs.deliveryConstraints.validateForm()){
          this.$emit('update-delivery-constraint',  this.deliveryConstraints)
        } else {
          {
            EventBus.$emit('displaySnackbar', {
              display: true,
              text: this.$t('deliveryMethod.incorrectFormFields'),
              color: 'error'
            })
          }
        }
      }
    }
  };
</script>